/* ================================================================
   QUICK ADD — wires every [data-quick-add] instance on the page.
   Pairs with snippets/quick-add.liquid + assets/quick-add.css.

   Per card:
     - Trigger opens the options panel over the product image.
     - Size chips + grind dropdown resolve to a variant id via the
       per-card JSON variant map.
     - Add to Cart POSTs to /cart/add.js (one-time, qty 1), refreshes
       the .cart-count badge from /cart.js, shows an "Added" state,
       then auto-closes.

   Only one panel is open at a time (opening one closes others).
   Escape and outside-click close the open panel. Works after the café
   grid re-sorts because listeners are bound to the card nodes, which
   the sort moves rather than recreates.
   ================================================================ */
(function () {
  'use strict';

  var openRoot = null;

  function closeOpen() {
    if (!openRoot) return;
    var panel = openRoot.querySelector('.qa-panel');
    var trigger = openRoot.querySelector('.qa-trigger');
    if (panel) panel.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    openRoot = null;
  }

  function updateCartBadge() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.querySelector('.cart-count');
        if (badge) badge.textContent = cart.item_count;
      })
      .catch(function () { /* badge refresh is best-effort */ });
  }

  function initInstance(root) {
    var trigger = root.querySelector('.qa-trigger');
    var panel   = root.querySelector('.qa-panel');
    var closeBtn= root.querySelector('.qa-close');
    var sizeBtns= [].slice.call(root.querySelectorAll('.qa-size'));
    var grindSel= root.querySelector('.qa-grind');
    var qtyDec  = root.querySelector('.qa-qty-dec');
    var qtyInc  = root.querySelector('.qa-qty-inc');
    var qtyVal  = root.querySelector('.qa-qty-val');
    var submit  = root.querySelector('.qa-submit');
    var priceEl = root.querySelector('.qa-price');
    var msgEl   = root.querySelector('.qa-msg');
    var mapEl   = root.querySelector('.qa-variant-map');
    if (!trigger || !panel || !submit || !mapEl) return;

    var map = {};
    try { map = JSON.parse(mapEl.textContent || '{}'); } catch (e) { map = {}; }

    var QTY_MAX = 99;
    var selSize = (sizeBtns[0] && sizeBtns[0].dataset.size) || '';
    var selGrind = grindSel ? grindSel.value : '';

    // Merch mode (snippets/quick-add.liquid): one chip group per product
    // option; the variant is keyed by the active values joined with "||".
    var optGroups = [].slice.call(root.querySelectorAll('[data-qa-opt]'));
    var optMode = root.hasAttribute('data-qa-options');

    function optSelection() {
      return optGroups.map(function (g) {
        var a = g.querySelector('.qa-opt.active');
        return a ? a.dataset.value : '';
      });
    }

    function key() {
      if (optMode) return optSelection().join('||');
      return selGrind + '||' + selSize;
    }

    function getQty() {
      var n = parseInt(qtyVal && qtyVal.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > QTY_MAX) n = QTY_MAX;
      return n;
    }

    function formatUSD(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function syncQtyButtons() {
      var q = getQty();
      if (qtyDec) qtyDec.disabled = q <= 1;
      if (qtyInc) qtyInc.disabled = q >= QTY_MAX;
    }

    function resolve() {
      var v = map[key()];
      var q = getQty();
      if (msgEl) msgEl.textContent = '';
      if (v) {
        submit.dataset.variantId = v.id;
        submit.disabled = !v.available;
        if (priceEl) {
          if (v.available) {
            // Multiply by qty for display (matches PDP behavior).
            // Use cents × qty for accuracy; fall back to priceMoney for qty 1.
            priceEl.textContent = (q > 1)
              ? ('· ' + formatUSD(v.price * q))
              : (v.priceMoney ? ('· ' + v.priceMoney) : '');
          } else {
            priceEl.textContent = '';
          }
        }
        if (!v.available && msgEl) msgEl.textContent = (window.qaI18n && qaI18n.soldOut) || 'That combination is sold out.';
      } else {
        delete submit.dataset.variantId;
        submit.disabled = true;
        if (priceEl) priceEl.textContent = '';
        if (msgEl) msgEl.textContent = (window.qaI18n && qaI18n.unavailable) || 'Unavailable.';
      }
      syncQtyButtons();
    }

    function openPanel() {
      if (openRoot && openRoot !== root) closeOpen();
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      openRoot = root;
      resolve();
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) openPanel(); else closeOpen();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeOpen();
      });
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        sizeBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        selSize = btn.dataset.size;
        resolve();
      });
    });

    optGroups.forEach(function (group, gi) {
      [].slice.call(group.querySelectorAll('.qa-opt')).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var sel = optSelection();
          sel[gi] = btn.dataset.value;
          if (!map[sel.join('||')]) {
            // That combination doesn't exist: move the other options to the
            // first variant that has the clicked value (prefer in stock).
            var pick = null;
            Object.keys(map).forEach(function (k) {
              var v = map[k];
              if (!v.options || v.options[gi] !== sel[gi]) return;
              if (!pick || (!pick.available && v.available)) pick = v;
            });
            if (pick) sel = pick.options.slice();
          }
          optGroups.forEach(function (g, i) {
            [].slice.call(g.querySelectorAll('.qa-opt')).forEach(function (b) {
              b.classList.toggle('active', b.dataset.value === sel[i]);
            });
          });
          resolve();
        });
      });
    });

    if (grindSel) {
      grindSel.addEventListener('change', function (e) {
        e.stopPropagation();
        selGrind = grindSel.value;
        resolve();
      });
      // The panel's click stopPropagation catches most events bubbling out
      // of the popup, but selects nested inside an ancestor <a> can trigger
      // anchor navigation in some browsers via the synthetic click that
      // fires after picking an option. Stop the click + mousedown here at
      // the source so the wrapping image-link never sees them.
      grindSel.addEventListener('click', function (e) { e.stopPropagation(); });
      grindSel.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    }

    function bumpQty(delta) {
      if (!qtyVal) return;
      var q = getQty() + delta;
      if (q < 1) q = 1;
      if (q > QTY_MAX) q = QTY_MAX;
      qtyVal.value = q;
      resolve();
    }
    if (qtyDec) qtyDec.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); bumpQty(-1);
    });
    if (qtyInc) qtyInc.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); bumpQty(1);
    });

    // Keep panel clicks from bubbling to the document outside-click handler.
    panel.addEventListener('click', function (e) { e.stopPropagation(); });

    submit.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = submit.dataset.variantId;
      if (!variantId || submit.disabled) return;

      var originalLabel = submit.querySelector('.qa-submit-label');
      var labelText = originalLabel ? originalLabel.textContent : 'Add to Cart';
      submit.disabled = true;
      if (originalLabel) originalLabel.textContent = (window.qaI18n && qaI18n.adding) || 'Adding…';

      var qty = getQty();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      }).then(function () {
        updateCartBadge();
        submit.classList.add('is-added');
        if (originalLabel) originalLabel.textContent = (window.qaI18n && qaI18n.added) || 'Added ✓';
        if (priceEl) priceEl.textContent = '';
        setTimeout(function () {
          closeOpen();
          submit.classList.remove('is-added');
          if (originalLabel) originalLabel.textContent = labelText;
          submit.disabled = false;
          if (qtyVal) qtyVal.value = 1;
          resolve();
        }, 1100);
      }).catch(function () {
        submit.disabled = false;
        if (originalLabel) originalLabel.textContent = labelText;
        if (msgEl) msgEl.textContent = (window.qaI18n && qaI18n.addError) || "Couldn’t add to cart. Try again.";
      });
    });

    // Seed price/availability for the default selection.
    resolve();
  }

  // Outside-click + Escape close the open panel.
  document.addEventListener('click', function () { closeOpen(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOpen();
  });

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-quick-add]')).forEach(function (root) {
      if (root.dataset.qaReady) return;
      root.dataset.qaReady = '1';
      initInstance(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
